<section class="business-intro-wrapper">
  <div class="box">
    <div class="box__left">
      <h1 class="box__heading color-gray">{{ 'BUSINESS_REGISTRATION.INTRO.HEADING' | translate }} </h1>

      <!-- list detail heading -->
      <div class="box__heading-detail-list" [innerHTML]="'BUSINESS_REGISTRATION.INTRO.DETAIL' | translate"> </div>

      <div class="box__pricing">
        <ng-container *ngFor="let item of serviceList">
          <span class="box__pricing-text">{{ 'BUSINESS_REGISTRATION.INTRO.PRICE_TAG.TOTAL' | translate }}</span>
          <span class="box__pricing-price">{{ item.data.price.iv }}.-</span>
          <span class="box__proicing-old-pricing"
            >{{ 'BUSINESS_REGISTRATION.INTRO.PRICE_TAG.ORIGINAL_PRICE' | translate }}
            <del>{{ item.data.normalPrice.iv }}.</del>-</span
          >
        </ng-container>
      </div>

      <div class="btn-wrapper">
        <a
          class="btn-try-free line"
          href="https://lin.ee/2hbDjsk"
          target="_blank"
          aria-label="link register contact team"
          ><img src="https://flowaccountcdn.com/new_landing/icon/line-contact-team.svg" alt="line contact team" /><span
            >{{ 'BUSINESS_REGISTRATION.INTRO.BTN_CONTACT_TEAM' | translate }}</span
          >
        </a>
        <a
          class="btn-try-free"
          href="https://form.flowaccount.com/th-th/businessregistrationservice"
          target="_blank"
          aria-label="link register try FlowAccount for free"
          ><span>{{ 'BUSINESS_REGISTRATION.INTRO.BTN_REGISTER_FOR_FREE' | translate }}</span>
        </a>
      </div>
      <span class="btn-wrapper-text">{{ 'BUSINESS_REGISTRATION.INTRO.TEXT_UNDER_BTN' | translate }}</span>
    </div>
    <div class="box__right">
      <picture>
        <source
          srcset="https://flowaccountcdn.com/new_landing/image/functions/business/business_header_v5.webp"
          type="image/webp"
        />
        <img
          src="https://flowaccountcdn.com/new_landing/image/business-registration/business_header_into.png"
          width="100%"
          loading="eager"
          alt="{{ 'BUSINESS_REGISTRATION.INTRO.ALT' | translate }}"
          class="box__image"
        />
      </picture>
    </div>
  </div>
</section>
